import { useTable, useSortBy } from 'react-table';
import './BaseTable.css';


function BaseTable({ columns, data, skipPageReset }) {

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
  } = useTable({
    columns,
    data,
    autoResetPage: !skipPageReset,
  }, useSortBy);

  const getRowClasses = (row) => {
    let classes = '';
    if (row.original.online_subs) {
      classes += 'online-subs';
    }
    if (row.original.blind_feelers) {
      if (classes) classes += ' ';
      classes += 'blind-feelers';
    }
    if (row.original.full_subs) {
      if (classes) classes += ' ';
      classes += 'full-subs';
    }

    if (classes) classes += ' ';
    if (row.original.status === 'Blacklisted') {
      classes += 'blacklisted';
    } else if (row.original.status === 'Do Not Contact') {
      classes += 'do-not-contact';
    } else if (row.original.status === 'Active') {
      classes += 'active';
    } else if (row.original.status === 'On Hold') {
      classes += 'on-hold';
    }
    return (classes) ? ({ className: classes }) : {};
  }

  return (<>
        <table {...getTableProps()}>
            <thead>
                {headerGroups.map(headerGroup => {
                    const { key, ...restOfRowProps } = headerGroup.getHeaderGroupProps();
                    return <tr key={key} {...restOfRowProps}>
                        {headerGroup.headers.map(column => {
                            // Add the sorting props to control sorting. For this example
                            // we can add them into the header props
                            const { key, ...restOfColumnProps } = column.getHeaderProps(column.getSortByToggleProps());
                            return <th key={key} {...restOfColumnProps}>
                                {column.render('Header')}
                                {/* Add a sort direction indicator */}
                              <span>
                                {column.isSorted
                                  ? column.isSortedDesc
                                    ? ' 🔽'
                                    : ' 🔼'
                                  : ''}
                              </span>
                            </th>
                        })}
                    </tr>
                })}
            </thead>
            <tbody {...getTableBodyProps()}>
                {rows.map(
                    (row) => {
                        prepareRow(row);
                        const { key, ...restOfRowProps } = row.getRowProps();
                        return (
                            <tr key={key} {...restOfRowProps} {...getRowClasses(row)}>
                                {row.cells.map(cell => {
                                    const { key, ...restOfCellProps } = cell.getCellProps();
                                    return <td key={key} {...restOfCellProps}>{cell.render('Cell')}</td>;
                                })}
                            </tr>
                        );
                    }
                )}
            </tbody>
        </table>

      { data.length > 0 &&
        <div className="total-count-row">
              Total Count: {" "}
              <strong>{data.length}</strong>
        </div>
      }
    </>);
}

export default BaseTable;

